import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    shortcut: {
        flexShrink: 0
    }
});
export default stylesheet;
